// icon:bx-broadcast | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Media.png";

function IconBxBroadcast(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Media"} />
	)
}

export default IconBxBroadcast;
